<template>
  <div>
    <v-sheet
      v-if="!doubleLine"
      class="d-flex justify-space-between"
      width="100%"
      color="transparent"
    >
      <div
        class="
          title
          primary--text
          font-italic font-weight-bold
          primary--text
          text-uppercase text-h4 text-sm-h3 text-center
          nowrap
        "
      >
        <slot />
      </div>
      <div
        class="before__title d-flex flex-column align-start justify-center pl-4"
      >
        <v-sheet class="line" width="100%" height="1px"></v-sheet>
        <v-sheet class="line" height="1px"></v-sheet>
      </div>
    </v-sheet>
    <v-sheet class="d-flex" v-else width="100%" color="transparent">
      <div
        class="after__title d-flex flex-column align-end justify-center pr-4"
      >
        <v-sheet class="line" width="100%" height="1px"></v-sheet>
        <v-sheet class="line" height="1px"></v-sheet>
      </div>
      <div
        class="
          title
          primary--text
          font-italic font-weight-bold
          primary--text
          text-uppercase text-h4 text-sm-h3 text-center
          nowrap
        "
      >
        <slot />
      </div>
      <div
        class="before__title d-flex flex-column align-start justify-center pl-4"
      >
        <v-sheet class="line" width="100%" height="1px"></v-sheet>
        <v-sheet class="line" height="1px"></v-sheet>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    doubleLine: {
      type: Boolean,
    },
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>
<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
.before__title,
.after__title {
  width: 100% !important;
  .line {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .line:nth-child(2) {
    width: calc(100% - 20px);
    margin-top: 5px;
  }
}
.after__title {
  .line:nth-child(2) {
    width: calc(100% - 20px);
    margin-top: 5px;
  }
}
</style>
